import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { FirstAidKit, Plus } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";
import { ComplaintEditor } from "@/components/ClinaraComplaintEditor";

// Bank Jawaban Keluhan Umum (disetujui bidan) — dikelola Super Admin.
export const ClinaraComplaintBank = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => api.get("/admin/clinara/complaints")
    .then((r) => setItems(r.data.items)).catch((e) => toast.error(apiError(e))), []);
  useEffect(() => { load(); }, [load]);
  const done = () => { setOpen(null); load(); };
  return (
    <div data-testid="clinara-complaint-bank" className="mt-4 rounded-2xl border border-rose-100/70 bg-white p-5">
      <div className="mb-1 flex items-center justify-between gap-2">
        <h2 className="flex items-center gap-1.5 text-sm font-bold text-slate-600"><FirstAidKit size={16} /> Bank Jawaban Keluhan & Katalog ({items.length})</h2>
        <button data-testid="complaint-add-btn" onClick={() => setOpen("new")}
          className="flex items-center gap-1 rounded-xl bg-rose-500 px-3 py-1.5 text-xs font-bold text-white transition-colors hover:bg-rose-600"><Plus size={14} /> Tambah</button>
      </div>
      <p className="mb-3 text-xs text-slate-400">Jawaban dikirim persis sesuai bank bila kata kunci cocok. Format: pembuka "Ini informasi umum, bukan pengganti pemeriksaan." → edukasi → tanda bahaya → layanan + link reservasi → "Ketik ADMIN…". Layanan yang tidak aktif di Master Layanan otomatis dilewati. Pertanyaan obat/dosis/hasil lab/USG/diagnosis, keluhan yang tidak cocok, atau "belum membaik" selalu dialihkan ke Admin. Jawaban jenis Katalog dikirim persis (tanpa pembuka) dan didahulukan dari harga otomatis Master Layanan.</p>
      {open === "new" && <ComplaintEditor onDone={done} onCancel={() => setOpen(null)} />}
      <ul className="space-y-2">
        {items.map((it) => (
          <li key={it.id} data-testid={`complaint-item-${it.id}`} className="rounded-xl bg-slate-50 px-3 py-2">
            {open === it.id ? <ComplaintEditor item={it} onDone={done} onCancel={() => setOpen(null)} /> : (
              <button data-testid={`complaint-open-${it.id}`} onClick={() => setOpen(it.id)} className="w-full text-left">
                <p className="text-sm font-bold text-slate-700">{it.kode ? `${it.kode} · ` : `${it.urutan}. `}{it.judul} <span className={`ml-1 rounded px-1.5 text-[10px] ${it.jenis === "katalog" ? "bg-violet-100 text-violet-600" : "bg-rose-100 text-rose-600"}`}>{it.jenis === "katalog" ? "katalog" : "keluhan"}</span> {!it.aktif && <span className="ml-1 rounded bg-slate-200 px-1.5 text-[10px] text-slate-500">nonaktif</span>}</p>
                <p className="truncate text-[11px] text-slate-400">Kata kunci: {(it.keywords || []).join(", ")}{it.konteks?.length ? ` · wajib ada: ${it.konteks.join(", ")}` : ""}</p>
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
